import { render, staticRenderFns } from "./PaymentBankChannels.vue?vue&type=template&id=ae927e9c&scoped=true&"
import script from "./PaymentBankChannels.vue?vue&type=script&lang=js&"
export * from "./PaymentBankChannels.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBankChannels.vue?vue&type=style&index=0&id=ae927e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae927e9c",
  null
  
)

export default component.exports